var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCipa1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 416,
    height: 537,
    viewBox: "0 0 416 537",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M218.49 297.409C220.875 363.594 223.259 429.794 225.629 495.979C222.412 498.119 217.356 502.097 213.363 508.661C206.469 520.008 207.388 531.412 207.862 535.29H341.884C344.196 530.091 352.225 510.414 343.578 494.284C332.303 473.256 295.563 463.547 258.894 482.133C256.021 420.558 253.134 358.984 250.262 297.409H218.476H218.49Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.83947,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M203.53 297.409C188.678 363.594 173.827 429.793 158.975 495.978C162.193 498.118 167.248 502.097 171.241 508.661C178.136 520.008 177.216 531.412 176.742 535.29H42.7062C40.7672 531.039 32.1924 511.131 41.0113 494.284C51.9416 473.414 86.3843 463.317 120.31 479.604C138.163 418.863 156.002 358.136 173.855 297.395H203.53V297.409Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.83947,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M199.088 316.29L193.753 340.197L160.588 344.29L170.836 312.29L199.088 316.29Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 1.83947,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M251.603 338.258L221.15 349.791L220.082 319.744L249.541 315.636L251.603 338.258Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 1.83947,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M227.234 65.3952L341.367 114.328L307.915 63.8345L231.355 46.835L227.234 65.3952Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 2.4058,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M225.307 52.7891C251.33 60.6109 282.543 73.2966 314.461 94.4516C324.301 100.973 333.252 107.674 341.356 114.311C343.037 105.801 342.553 98.7154 341.206 92.953C333.489 59.9066 289.299 35.985 231.378 30.8947C229.355 38.1884 227.332 45.4821 225.31 52.7759L225.307 52.7891Z",
    fill: "#5B5BD8",
    stroke: "#1E1E1E",
    strokeWidth: 2.4058,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0988 228.191C62.9471 221.72 37.8832 208.684 21.7678 182.624C20.238 180.14 1.64209 149.389 11.2675 138.906C17.5644 132.035 31.5394 138.695 60.5513 143.526C83.2939 147.318 102.435 147.856 115.525 147.649",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0988 228.191C62.9471 221.72 37.8832 208.684 21.7678 182.624C20.238 180.14 1.64209 149.389 11.2675 138.906C17.5644 132.035 31.5394 138.695 60.5513 143.526C83.2939 147.318 102.435 147.856 115.525 147.649",
    stroke: "#1E1E1E",
    strokeWidth: 2.4058,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M183.993 29.5733C109.19 44.3242 31.9465 180.605 85.6553 268.557C131.951 344.371 249.113 340.964 316.32 311.049C374.44 285.168 424.086 226.621 412.767 205.896C404.8 191.335 359.999 196.41 329.573 202.965C329.927 188.799 329.364 172.27 326.929 154C324.074 132.553 316.687 113.984 311.756 98.8084C304.95 87.4036 292.342 53.0833 247.885 36.8472C242.312 34.8074 211.819 24.0891 184.007 29.5731L183.993 29.5733Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 2.4058,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M238.649 177.379L238.663 177.378C254.744 177.225 267.657 164.064 267.503 147.982L267.453 142.709C267.299 126.627 254.138 113.715 238.057 113.868L238.043 113.868C221.961 114.022 209.049 127.183 209.203 143.264L209.253 148.538C209.406 164.62 222.567 177.532 238.649 177.379Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 2.4058,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M238.429 164.216C245.672 164.146 251.464 155.745 251.366 145.45C251.267 135.156 245.316 126.866 238.073 126.935C230.83 127.005 225.037 135.406 225.136 145.701C225.234 155.995 231.185 164.285 238.429 164.216Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 2.4058,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M242.202 124.553L237.347 139.334L254.426 136.366L242.202 124.553Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M163.587 177.379L163.601 177.378C179.683 177.225 192.595 164.064 192.442 147.982L192.391 142.709C192.238 126.627 179.077 113.715 162.995 113.868L162.981 113.868C146.9 114.022 133.988 127.183 134.141 143.264L134.191 148.538C134.345 164.62 147.506 177.532 163.587 177.379Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 2.4058,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M163.367 164.216C170.61 164.146 176.402 155.745 176.304 145.45C176.206 135.156 170.255 126.866 163.011 126.935C155.768 127.005 149.976 135.406 150.074 145.701C150.172 155.995 156.124 164.285 163.367 164.216Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 2.4058,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M167.14 124.553L162.286 139.334L179.364 136.366L167.14 124.553Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M261.423 94.3587L238.496 90.607C234.055 89.8802 229.866 92.8913 229.139 97.3325L228.826 99.2465C228.099 103.688 231.11 107.877 235.551 108.604L258.478 112.356C262.919 113.082 267.108 110.071 267.835 105.63L268.148 103.716C268.875 99.275 265.864 95.0855 261.423 94.3587Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 2.4058,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M146.707 109.864L169.96 108.166C174.425 107.84 177.78 103.955 177.454 99.4902L177.307 97.4724C176.981 93.0072 173.096 89.6518 168.631 89.978L145.378 91.6765C140.913 92.0027 137.557 95.8869 137.884 100.352L138.031 102.37C138.357 106.835 142.241 110.191 146.707 109.864Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 2.4058,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M104.869 90.4948C110.442 56.5722 142.319 1.20372 209.812 1.2031C277.306 1.20248 297.493 56.09 305.793 90.4948C305.793 90.4948 260.816 73.4176 204.52 73.4176C148.224 73.4176 104.869 90.4948 104.869 90.4948Z",
    fill: "#5B5BD8",
    stroke: "#1E1E1E",
    strokeWidth: 2.4058,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M201.935 31.5518C223.076 31.5518 228.806 47.8618 228.806 58.7373C228.806 58.7373 213.409 56.5721 202.463 56.5721C191.517 56.5721 176.119 58.7373 176.119 58.7373C176.119 48.7076 180.795 31.5518 201.935 31.5518Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 2.4058
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M172.992 58.978C201.573 53.59 231.654 59.1384 243.121 62.9476C243.121 64.9685 243.602 72.2099 243.602 75.8186C215.454 71.8486 190.033 72.9713 172.992 74.8559C167.749 75.3921 162.537 73.5327 162.537 68.1196C162.537 62.7066 167.711 59.9736 172.992 58.978Z",
    fill: "#5B5BD8",
    stroke: "#1E1E1E",
    strokeWidth: 2.4058
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M201.762 196.228C216.71 196.228 221.103 185.301 220.939 180.187H181.602C181.602 184.371 183.077 196.228 201.762 196.228Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 2.4058
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M201.271 161.705C219.759 161.705 227.331 172.632 228.806 178.095L200.779 184.721L172.751 178.095C174.554 172.632 182.782 161.705 201.271 161.705Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 2.4058
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M314.707 228.191C331.859 221.72 356.923 208.684 373.038 182.624C374.568 180.14 393.164 149.389 383.539 138.906C377.242 132.035 363.267 138.695 334.255 143.526C311.512 147.318 292.371 147.856 279.281 147.649",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M314.707 228.191C331.859 221.72 356.923 208.684 373.038 182.624C374.568 180.14 393.164 149.389 383.539 138.906C377.242 132.035 363.267 138.695 334.255 143.526C311.512 147.318 292.371 147.856 279.281 147.649",
    stroke: "#1E1E1E",
    strokeWidth: 2.4058,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCipa1);
export default __webpack_public_path__ + "static/media/cipa1.22e831b572d56abcad0db607eb1182bf.svg";
export { ForwardRef as ReactComponent };